<!--  -->
<template>
  <div>
    <el-dialog
      :title="$t('layout.视频布局')"
      :close-on-click-modal="false"
      v-bind="$attrs"
      v-on="$listeners"
      width="760px"
    >
      <iframe :src="url" class="iframeStyle" id="layoutIframe"> </iframe>
    </el-dialog>
    <el-dialog width="760px" class="layout-publish-dialog" :title="layoutPublishTitle" :visible.sync="layoutPublishVisible" :close-on-click-modal="false" append-to-body>
      <iframe :src="layoutPublishUrl" class="iframeStyle"> </iframe>
    </el-dialog>
  </div>
</template>

<script>
import { getParameter } from "@/utils/global";
export default {
  name: "layout",
  data() {
    return {
      url: "",
      roomId: getParameter("roomId"),
      layoutPublishUrl: "",
      layoutPublishVisible: false,
      layoutPublishTitle: ""
    };
  },
  components: {},
  watch: {
    $attrs: {
      handler(value) {
        // console.log(value);
        if (value.visible) {
          this.init();
        }
      },
    },
    avctl: {
      immediate: true,
      handler(n) {
        if (!n) {
          this.layoutPublishVisible = false
        }
        if (!n && this.$attrs.visible) {
          this.$alert(this.$t('layout.您的主控权已被转移'), this.$t('layout.提示'), {
          confirmButtonText: this.$t('layout.我知道了'),
          callback: () => {
            this.$emit('update:visible', false);
          }
        });
        }
      },
    }
  },
  computed: {
    authCheckToken() {
      return this.$store.getters.authCheckToken;
    },
    avctl() {
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.avctl
      );
    },
  },
  mounted() {
    window.addEventListener("message", (layoutDate) => {
      if (!layoutDate && !layoutDate.data) {
        return null;
      }
      console.log(layoutDate, "layoutDate");
      switch (layoutDate.data.type) {
        case "PublishLayout": {
          /**布局发布布局弹窗 */
          this.layoutPublishUrl =
            layoutDate.data.type === "PublishLayout" ? "https:" + layoutDate.data.url : "";
          this.layoutPublishVisible = layoutDate.data.type === "PublishLayout";
          this.layoutPublishTitle = layoutDate.data.layoutName;
          // this.$parent.openLayout = false;
          break;
        }
        case "choseLayoutChange": {
          /**布局选择布局回调 */
          let layoutIframeDom = document.getElementById("layoutIframe");
          layoutIframeDom.contentWindow.postMessage(
            { type: "choseLayoutChange", params: layoutDate.data.params },
            "*"
          );
          this.layoutPublishUrl = "";
          this.layoutPublishVisible = false;
          this.layoutPublishTitle = "";
          break;
        }
        case "layoutStart": {
          /**布局初始化获取信息 */
          let layoutIframeDom = document.getElementById("layoutIframe");
          layoutIframeDom.contentWindow.postMessage(
            {
              assistantToken: this.authCheckToken,
              liveCid: this.$store.getters.userInfo.cid, //当前登陆人的cid,cc的cid
              liveId: getParameter("liveId"), //直播id
            },
            "*"
          );
          break;
        }
      }
    });
  },
  methods: {
    init() {
      this.url = `${config.layoutUrl}?r=${this.roomId}&t=${this.authCheckToken}&type=yb&u=guest&operatorRole=0`;
    },
  },
};
</script>
<style lang="scss" scoped>
.iframeStyle {
  border: 0 none;
  width: 100%;
  height: 452px;
}

::v-deep .el-dialog__header {
  background: #f1f1f1;
  padding-top: 10px;
}
::v-deep .el-dialog__body {
  background: #fff;
}
::v-deep .el-dialog__headerbtn {
  top: 12px;
}
::v-deep .el-dialog__body {
  padding: 0;
}
</style>
